/**
 *
 * AdditionalInformation
 *
 */

import React from "react";
import { IntlPropType } from "root/libs/core-libs/src";
import { DhlText } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";
import PropTypes from "prop-types";
import { businessUnits } from "root/libs/constants/src";
import globalConfiguration from "one-time-shipment/src/config/globalConfiguration";
import {
  AdditionalInformationWrapper,
  AdditionalInformationHeadline,
  AdditionalInformationList,
  StyledNoticeText,
} from "./styled";

const {
  offersLane: { serviceSuspensionZones, emergencySurchargeUnit },
} = globalConfiguration;

const COPY_ID_PREFIX = "CardAndSummary";

const AdditionalInformation = ({
  intl,
  additionalInformationList,
  businessUnit = "",
  bussinessUnitKey = "",
  isStaticOffer = false,
  destinationCountry = "",
}) => {
  const getCopy = (id, values, prefix = COPY_ID_PREFIX) => {
    return intl.formatMessage({ id: `${prefix}.${id}` }, values);
  };

  const headlineString = getCopy("additionalInformation");

  const isOceanFright = () =>
    bussinessUnitKey?.includes(emergencySurchargeUnit);

  const showSuspesionMessage = () =>
    businessUnit === businessUnits.DGF &&
    !isStaticOffer &&
    serviceSuspensionZones.includes(destinationCountry);

  const showEmergencySurchargeMessage = () =>
    showSuspesionMessage && destinationCountry === "IL" && isOceanFright();

  return (
    additionalInformationList &&
    additionalInformationList.length !== 0 && (
      <AdditionalInformationWrapper>
        <AdditionalInformationHeadline priority={5} weight="700">
          {headlineString}
        </AdditionalInformationHeadline>
        <AdditionalInformationList>
          {additionalInformationList.map((item) => (
            <li key={item.key}>
              <DhlText size={Sizes.XS} isParagraph>
                {getCopy(
                  `${item.key}_description`,
                  undefined,
                  "AdditionalInformationMessages"
                )}
              </DhlText>
            </li>
          ))}

          {showSuspesionMessage() && (
            <StyledNoticeText>
              <AdditionalInformationHeadline priority={5} weight="700">
                {getCopy(
                  "SUSPENSION_title",
                  undefined,
                  "AdditionalInformationMessages"
                )}
              </AdditionalInformationHeadline>
              <DhlText size={Sizes.XS} isParagraph>
                {getCopy(
                  destinationCountry === "IL"
                    ? "IL_SUSPENSION_description"
                    : "BY_SUSPENSION_description",
                  undefined,
                  "AdditionalInformationMessages"
                )}
              </DhlText>
            </StyledNoticeText>
          )}

          {showEmergencySurchargeMessage() && (
            <StyledNoticeText>
              <AdditionalInformationHeadline priority={5} weight="700">
                {getCopy(
                  "EMERGENCY_SURCHARGE_title",
                  undefined,
                  "AdditionalInformationMessages"
                )}
              </AdditionalInformationHeadline>
              <DhlText size={Sizes.XS} isParagraph>
                {getCopy(
                  "EMERGENCY_SURCHARGE_description",
                  undefined,
                  "AdditionalInformationMessages"
                )}
              </DhlText>
            </StyledNoticeText>
          )}
        </AdditionalInformationList>
      </AdditionalInformationWrapper>
    )
  );
};

AdditionalInformation.propTypes = {
  /** These are the items of additional information that are added to an offer */
  additionalInformationList: PropTypes.array.isRequired,
  /** Translations library  */
  intl: IntlPropType.isRequired,
  businessUnit: PropTypes.string,
  bussinessUnitKey: PropTypes.string,
  isStaticOffer: PropTypes.bool,
  destinationCountry: PropTypes.string,
};

export default AdditionalInformation;
